import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const navLinks = [
  { label: '首页', to: '/' },
  { label: '漫画分类', to: '/category' },
  { label: '最新更新', to: '/category/hot' },
  { label: '反转剧场', to: '/category/reversal' },
  { label: '关于我们', to: '/about' },
  { label: '联系我们', to: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/category?q=${encodeURIComponent(q)}` : '/category');
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'border-b border-background-200/70 bg-background-50/95 shadow-sm backdrop-blur' : 'bg-transparent'
      }`}
    >
      <div className="container-page flex h-16 items-center justify-between gap-4 md:h-18">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-emotion-laugh-fill text-lg" aria-hidden="true" />
          </span>
          <span className="font-heading text-xl text-foreground-950">
            歪歪<span className="text-primary-600">漫画</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((item) => {
            const active =
              item.to === '/'
                ? location.pathname === '/'
                : item.to === '/category'
                  ? location.pathname === '/category' || /^\/category\/[^/]+$/.test(location.pathname) && item.to === '/category'
                  : location.pathname === item.to;
            return (
              <Link
                key={item.label}
                to={item.to}
                className={`whitespace-nowrap rounded-full px-3.5 py-2 text-sm transition-colors md:px-4 ${
                  active ? 'bg-primary-100 font-bold text-primary-700' : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <form onSubmit={submitSearch} className="flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3 py-1.5">
            <i className="ri-search-line text-sm text-foreground-500" aria-hidden="true" />
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索作品名 / 标签"
              className="w-36 bg-transparent text-sm outline-none placeholder:text-foreground-400"
              aria-label="搜索漫画"
            />
          </form>
          <Link
            to="/category/hot"
            className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            立即开看
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-700 md:hidden"
          aria-label={open ? '关闭菜单' : '打开菜单'}
          aria-expanded={open}
        >
          <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} aria-hidden="true" />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-4 md:hidden">
          <form onSubmit={submitSearch} className="mb-3 flex items-center gap-2 rounded-full border border-background-200 px-3 py-2">
            <i className="ri-search-line text-foreground-500" aria-hidden="true" />
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索作品名 / 标签"
              className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
              aria-label="搜索漫画"
            />
          </form>
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100"
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}